export const AT = 'at';

export function goLoginOrSignUp(language, query = {}) {
  //电商版跳转https://www.adspolar.com/m/sign-up?source=xmp
  if (window.location.href.includes('ecommerce')) {
    window.open('https://www.adspolar.com/m/sign-up?source=xmp', '_blank')
    return
  }

  const token = window.localStorage.getItem('at');
  const host = window.location.host;

  const lang = language === 'cn' ? 'zh-CN' : 'en-US';
  let queryList = [];
  // 页面访问链接自带参数
  if(window.location.search?.[0] === '?') {
    queryList.push(window.location.search.slice(1))
  }
  // 页面调用时自带参数
  if(Object.keys(query).length > 0) {
    Object.keys(query).forEach(k => {
      queryList.push(`${k}=${query[k]}`);
    })
  }// 应用版
  if(window.location.href.includes('appsolution')) {
    queryList.push('mode=1')
  }
  queryList.push(`landing_site=official_${language}&lang=${lang}`)

  const search = queryList.join('&')

  const url = `//${host}/m/${token ? 'login' : 'sign-up'}?${search}`;

  window.open(url, '_blank');
}